import { render } from "./ControlLabel.vue?vue&type=template&id=362c11b7&ts=true&lang=pug"
import script from "./ControlLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlLabel.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__